import { AbstractControl, ValidatorFn } from '@angular/forms';

export function PatternValidator(pattern: string | RegExp): ValidatorFn {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (control: AbstractControl): { [key: string]: any } | null => {
    const getVal = (ctrl: AbstractControl): string =>
      ctrl && ctrl.value && ctrl.value.value ? ctrl.value.value : null;
    const val = getVal(control);
    if (val) {
      return !val.match(pattern)
        ? {
            pattern: {
              value: val,
              match: pattern
            }
          }
        : null;
    } else {
      return null;
    }
  };
}
